/**
 * @generated SignedSource<<ec6b16a02c6631ccf8189c0524b63756>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveBindingMutation$variables = {
  connections: ReadonlyArray<string>;
  names: ReadonlyArray<string>;
  uuid: string;
};
export type RemoveBindingMutation$data = {
  readonly removeBinding: {
    readonly binding: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
  readonly removeReportGroups: ReadonlyArray<string>;
};
export type RemoveBindingMutation = {
  response: RemoveBindingMutation$data;
  variables: RemoveBindingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "names"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v3 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "uuid"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "names",
    "variableName": "names"
  }
],
v6 = {
  "alias": null,
  "args": (v5/*:: as any*/),
  "kind": "ScalarField",
  "name": "removeReportGroups",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveBindingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "BindingPayload",
        "kind": "LinkedField",
        "name": "removeBinding",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Binding",
            "kind": "LinkedField",
            "name": "binding",
            "plural": false,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v6/*:: as any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "RemoveBindingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "BindingPayload",
        "kind": "LinkedField",
        "name": "removeBinding",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Binding",
            "kind": "LinkedField",
            "name": "binding",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v6/*:: as any*/),
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "removeReportGroups",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f619218a02fde44b4e9c2425383a7f85",
    "id": null,
    "metadata": {},
    "name": "RemoveBindingMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveBindingMutation(\n  $uuid: String!\n  $names: [String!]!\n) {\n  removeBinding(uuid: $uuid) {\n    binding {\n      id\n    }\n  }\n  removeReportGroups(names: $names)\n}\n"
  }
};
})();

(node as any).hash = "70d7300d9b31f59e752018f4e85fc417";

export default node;
